import { render, staticRenderFns } from "./ExpandableCard.vue?vue&type=template&id=64698dd4"
import script from "./ExpandableCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpandableCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports